import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { ClipLoader } from "react-spinners";
import "../report.css"
import { FaCalendarAlt } from "react-icons/fa";
import { ReactComponent as Chart } from '../../../../../POS/assets/images/svgIcons/Chart.svg';
import GridReport from './grid';
import ApiService from '../../../../services/apiService';

const GridView = ({ Currency }) => {
    let navigate = useNavigate();
    const [selectedFilter, setSelectedFilter] = useState('0');
    const [data, setData] = useState([]);

    useEffect(() => {
        getReportData()
    }, [selectedFilter]);
    const handleFilterChange = async (selectedFilter) => {
        setSelectedFilter(selectedFilter?.value);
        console.log('Selected Option:', selectedFilter);
        await getReportData();
    };
    const getReportData = async () => {
        try {
            const apiService = new ApiService();
            let paramaters = `?GetBy=${selectedFilter}`;
            let res = await apiService.getApiParamater("GET_SALE_REPORTS", paramaters);
            // Filter results based on paymentMethod
            let filteredData = res?.data?.result.filter(item => item.paymentMethod >= 0);
            setData(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const ThirdFilter = [
        { value: '0', label: 'Day' },
        { value: '1', label: 'Week' },
        { value: '2', label: 'Month' },
        { value: '3', label: 'Year' },
        { value: '4', label: 'All Time' },
    ];
    const handlechart = () => {
        navigate('/admin/Reports/home')
    }
    return (
        <div className='p-lg-5'>
            <div className='px-lg-5'>
                <div className='d-flex justify-content-between' >
                    <div className='d-flex justify-content-between gap-4' >
                        <div className='viebtn' onClick={() => handlechart()}><Chart /></div>
                        {/* <div>
                            <input className='form-control' type='search' placeholder='Search' />
                        </div>
                        <div>
                            <input className='form-control' type='search' placeholder='Search' />
                        </div> */}
                    </div>
                    {/* <div className='d-flex mbl-center gap-3'>
                        <div className='d-flex'>
                            <nav className="nav nav-pills weekfilter ">
                                {ThirdFilter?.map((filter) => (
                                    <button
                                        key={filter.value}
                                        className={`nav-link ${selectedFilter === filter.value ? 'activecls' : ''}`}
                                        onClick={() => handleFilterChange(filter)}
                                    >
                                        {filter.label}
                                    </button>
                                ))}
                            </nav>
                        </div>
                        <div className='custom center gap-2'>Custom <FaCalendarAlt /></div>
                    </div> */}
                </div>
                <div className='pt-5'>
                    <GridReport data={data}/>
                </div>
            </div>
        </div>
    );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(GridView);